module.exports = __webpack_public_path__ + "assets/alert-triangle-0f6d4b.svg";